import { render, staticRenderFns } from "./ListAudios.vue?vue&type=template&id=6a4d799b&"
import script from "./ListAudios.vue?vue&type=script&lang=js&"
export * from "./ListAudios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports